import AbstractPacker from "_src/engine/packers/abstract_packer";
import unzip from "_unzip";
import { zipSync } from "fflate";

export default class Zipper extends AbstractPacker {
  unpackData(data) {
    return new Promise((resolve) => {
      unzip(new Uint8Array(data), (err, directory) => {

        const entries = [];
        for (const entryName in directory) {
          entries.push({name : entryName, payload : directory[entryName]});
        }

        const sortedEntries = entries.sort((a, b) => {
          const matchA = a.name.match(/[0-9]+/);
          const matchB = b.name.match(/[0-9]+/);

          if (matchA && matchB) {
            return parseFloat(matchA[0]) - parseFloat(matchB[0]);
          } else {
            return a.name > b.name ? 1 : -1;
          }
        });

        const buffersData = [];
        for (const entry of sortedEntries) {

          const bufferData = entry.payload;
          buffersData.push(bufferData.buffer);
        }

        resolve(buffersData);
      });
    });
  }

  packData(buffers) {
    const zipParams = {level: 0};
    const centralDirectory = {};
    for (let i=0; i<buffers.length; i++) {
      centralDirectory[i.toString()] = buffers[i];
    }

    const zipped = zipSync(centralDirectory, zipParams);
    return Array.from(zipped);
  }
}
